const actions = {
  REQUESTING: 'Proposals/REQUESTING',
  RESPONSE_ERROR: 'Proposals/RESPONSE_ERROR',

  FETCH_PROPOSALS: 'Proposals/FETCH',
  LIST_PROPOSAL: 'Proposal/LIST',

  FETCH_PROPOSALS_FOR_APPROVEMENT: 'Proposals/FETCH_FOR_APPROVEMENT',
  LIST_PROPOSAL_FOR_APPROVEMENT: 'Proposal/LIST_FOR_APPROVEMENT',

  FETCH_PROPOSAL: 'Proposal/FETCH',
  FETCH_PROPOSAL_PREVIEW: 'Proposal/FETCH_PREVIEW',

  EDIT_PROPOSAL: 'Proposal/EDIT',

  RE_FETCH_PROPOSALS: 'Proposals/REFRESH',
  SAVE_PROPOSAL: 'Proposal/SAVE',
  SAVE_PROPOSAL_RECIEVED: 'Proposal/SAVE_PROPOSAL_RECIEVED',

  DELETE_PROPOSAL: 'Proposal/DELETE',
  DELETE_PROPOSAL_RECIEVED: 'Proposal/DELETE_RECIEVED',

  CREATE_PROPOSAL: 'CREATE_PROPOSAL',
  CREATE_PROPOSAL_RECIEVED: 'CREATE_PROPOSAL_RECIEVED',

  RESET_PROPOSAL: 'RESET_PROPOSAL',
  RESET_PROPOSAL_RECIEVED: 'RESET_PROPOSAL_RECIEVED',

  CREATE_RESET_PROPOSAL_RECIEVED: 'CREATE_RESET_PROPOSAL_RECIEVED',
  CREATE_RESET_PROPOSAL: 'CREATE_RESET_PROPOSAL',

  Refresh: 'Refresh_Proposal',
  Refresh_Recieved: 'Refresh_Proposal_recieved',

  Refresh_reset: 'Refresh_reset',
  Refresh_reset_Recieved: 'Refresh_reset_Recieved',

  COPY_PROPOSAL_RECIEVED: 'COPY_PROPOSAL_RECIEVED',
  COPY_PROPOSAL: 'COPY_PROPOSAL',

  COPY_PROPOSAL_RESET_RECIEVED: 'COPY_PROPOSAL_RESET_RECIEVED',
  COPY_PROPOSAL_RESET: 'COPY_PROPOSAL_RESET',

  FETCH_COST_VIEW: 'Proposal/FETCH_COST_VIEW',
  FETCH_COST_VIEW_RECIEVED: 'Proposal/FETCH_COST_VIEW_RECIEVED',

  SEND_TO_APPROVEMENT: 'Proposal/SEND_TO_APPROVEMENT',
  SEND_TO_APPROVEMENT_RECIEVED: 'Proposal/SEND_TO_APPROVEMENT_RECIEVED',

  APPROVE_PROPOSAL: 'Proposal/APPROVE_PROPOSAL',
  APPROVE_PROPOSAL_RECIEVED: 'Proposal/APPROVE_PROPOSAL_RECIEVED',

  REJECT_PROPOSAL: 'Proposal/REJECT_PROPOSAL',
  REJECT_PROPOSAL_RECIEVED: 'Proposal/REJECT_PROPOSAL_RECIEVED',

  CANCEL_PROPOSAL: 'Proposal/CANCEL_PROPOSAL',
  CANCEL_PROPOSAL_RECIEVED: 'Proposal/CANCEL_PROPOSAL_RECIEVED',
}

export default actions
